import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { Order } from '@alliance-disposal/transport-types';
import { getOrderStatusColorForCustomer } from '@wayste/client-utils';
import { CustomFormContext } from '../../../formWrapper/SourSearchWrapper';
///////////////////////////////////////////////
// STATUS PILL COMPONENT
///////////////////////////////////////////////
export const StatusPill = ({ status }) => {
    const { application } = useContext(CustomFormContext);
    const [label, setLabel] = useState('');
    useEffect(() => {
        if (application === 'aap') {
            // console.log('PAYLOAD status', status, Order.SourgumOrderStatusLabels[status]);
            setLabel(Order.SourgumOrderStatusLabels[status]);
        }
        if (application === 'wayste') {
            setLabel(Order.WaysteOrderStatusLabels[status]);
        }
        // FOR CUSTOMER PORTAL APPLY SPECIAL LABEL AND COLORS
        if (application === 'customer-portal') {
            setLabel(Order.CustomerPortalOrderStatusLabels[status]);
            getOrderStatusColorForCustomer(status);
        }
    }, [application, status]);
    ///////////////////////////////////////////////
    // RENDER
    ///////////////////////////////////////////////
    switch (status) {
        case 'NEEDS_REVIEW':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-NEEDS_REVIEW-pill-background text-statuses-NEEDS_REVIEW-pill-text'} `, children: label }));
        case 'UNASSIGNED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-UNASSIGNED-pill-background text-statuses-UNASSIGNED-pill-text'} `, children: label }));
        case 'ON_HOLD':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-ON_HOLD-pill-background text-statuses-ON_HOLD-pill-text'} `, children: label }));
        case 'ASSIGNED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-ASSIGNED-pill-background text-statuses-ASSIGNED-pill-text'} `, children: label }));
        case 'DELIVERED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-DELIVERED-pill-background text-statuses-DELIVERED-pill-text'} `, children: label }));
        case 'READY_FULL_PICKUP':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-READY_FULL_PICKUP-pill-background text-statuses-READY_FULL_PICKUP-pill-text'} `, children: label }));
        case 'READY_EMPTY_PICKUP':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-READY_EMPTY_PICKUP-pill-background text-statuses-READY_EMPTY_PICKUP-pill-text'} `, children: label }));
        case 'PICKED_UP_FULL':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-PICKED_UP_FULL-pill-background text-statuses-PICKED_UP_FULL-pill-text'} `, children: label }));
        case 'PICKED_UP_EMPTY':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-PICKED_UP_EMPTY-pill-background text-statuses-PICKED_UP_EMPTY-pill-text'} `, children: label }));
        case 'DUMPED':
            return (_jsx("span", { className: `inline-block overflow-hidden whitespace-nowrap rounded-full px-3 py-0.5 text-xs overflow-ellipsis${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-DUMPED-pill-background text-statuses-DUMPED-pill-text'} `, children: label }));
        case 'COMPLETED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-COMPLETED-pill-background text-statuses-COMPLETED-pill-text'} `, children: label }));
        case 'CANCELLED':
            return (_jsx("span", { className: `inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs ${application === 'customer-portal'
                    ? getOrderStatusColorForCustomer(status)
                    : 'bg-statuses-CANCELLED-pill-background text-statuses-CANCELLED-pill-text'} `, children: label }));
        default:
            return _jsx(_Fragment, {});
    }
};
//# sourceMappingURL=StatusPill.js.map